import Firestore from "../data/Firestore"
import Vue from 'vue'

export default class {

    static addToArray(arr, item, options) {
        
        if(!this.validateArrayAndItem(arr, item) )
            return
        this.markupItem(item)
        
        item._array = arr
        arr.push(item)
    }

    static isLastItem(arr, item) {
        if(!this.validateArrayAndItem(arr, item) )
            return

        const lastItem = this.getLastItem(arr)
        return Boolean(lastItem._id == item._id)
    }

    static getLastItem(arr) {
        return arr[arr.length - 1]
    }

    static markupItem(item) {
        item._id = item._id || Firestore.getId()
    }

    static validateArrayAndItem(arr, item) {
        if(!arr || !item) {
            console.log('validateArrayAndItem was passed an invalid parameter', arr, item) 
            return false
        }
        return true
    }

    static getNextItem(arr, item) {
        if(!this.validateArrayAndItem(arr, item) )
            return

        const idx = arr.findIndex(o => o._id == item._id)
        if(idx < (arr.length - 1))
            return arr[idx + 1]
        else
            return null
    }

    static getPreviousItem(arr, item) {
        if(!this.validateArrayAndItem(arr, item) )
            return

        const idx = arr.findIndex(o => o._id == item._id)
        if(idx > 0)
            return arr[idx - 1]
        else
            return null
    }

    // static fetchInvite(tenantKey) {
    //     return new Promise( (resolve, reject) => {
    //         const ref = DataHelpers.getRootRef().child('invites').child(tenantKey)
    //         NiceData.fetchItemSingle(ref).then(item => {
    //             resolve(item)
    //         }).catch(err => {
    //             reject (err)
    //         })         
    //     })
    // }

    // Selection

    static selectOneOrToggle(arr, item) {
        const selectedItems = this.getSelected(arr)
        if(selectedItems.length > 1)
            this.selectOne(arr, step)   
        else
            this.toggleSelection(step)
    }


    static toggleSelection(item) {
        Vue.set(item, '_selected', !item._selected)
    }

    static selectItem(item) {
        Vue.set(item, '_selected', true)
    }

    static selectOne(arr, selectItem) {
        this.unselectAll(arr)
        Vue.set(selectItem, '_selected', true)
    }

    static getSelected(arr) {
        return arr.filter(o => o._selected)
    }

    static unselectAll(arr) {
        arr.forEach(item => {
            Vue.set(item, '_selected', false)
        })
    }

    static selectRange(arr, step) {
        
        let indexes = []
        let stepIndex = arr.findIndex(o => o._id == step._id)
        indexes.push(stepIndex)

        const selectedItems = this.getSelected(arr)
        const firstSelectedItem = selectedItems[0]
        const lastSelectedItem = this.getLastItem(selectedItems)

        const lowestIndex = arr.findIndex(o => o._id == firstSelectedItem._id)
        const highestIndex = arr.findIndex(o => o._id == lastSelectedItem._id)

        indexes.push(lowestIndex)
        indexes.push(highestIndex)

        const min = Math.min(...indexes)
        const max = Math.max(...indexes)

        for(var n = min; n <= max; n++) {
            this.selectItem(arr[n])
        }
    }

     
}


// WEBPACK FOOTER //
// ./src/helpers/ObjectArrayHelpers.js